import React from 'react'
import {useState, useEffect} from 'react'
import {
  Row,
  message,
  Input,
  Col,
  Button,
  Form,
  Select,
  Modal,
  Table,
  DatePicker,
  Popconfirm,
  Result,
  Layout,
  Tooltip,
} from 'antd'
import Layouts from '../src/components/Layouts'
import {DownloadOutlined, InfoCircleOutlined} from '@ant-design/icons'
import {saveAs} from 'file-saver'
import cancelClaimNote from './cancelClaimNote'
import moment from 'moment'
import ViewPolicyClaim from './ViewPolicy'
import apiRequest from './hooks/apiRequest'
import { toast } from 'react-toastify'
export default function AuthoriseClaim() {
  const [claimData, setClaimData] = useState()
  const [claimActivity, setClaimActivity] = useState()
  const [loading, setLoading] = useState(false)
  const [uploadedDoc, setUploadedDoc] = useState([])
  const [cancelPopup, setCancelPopup] = useState(false)
  const [policyData, setPolicyData] = useState()
  const [dataForMotor, setDataForMotor] = useState()
  const [viewPolicy, setViewPolicy] = useState(false)

  useEffect(() => {
    const fetchClaimInfo = async () => {
      setLoading(true);
      const claimId = localStorage.getItem('claimId');
  
      try {
        const claimRes = await apiRequest(
          process.env.REACT_APP_BASE_URL + '/claim/GetClaimById/' + claimId,
          'GET'
        );
        // debugger
        setClaimData(claimRes?.data?.result?.claim_creation);
        setClaimActivity(claimRes?.data?.result?.claim_activity);
  
        const quotationRes = await apiRequest(
          process.env.REACT_APP_BASE_URL + '/claim/GetClaimQuotation/' + claimId,
          'GET'
        );
        console.log('quotationRes',quotationRes);
        setUploadedDoc(quotationRes?.data);
      } catch (error) {
        console.error('Error fetching claim details:', error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchClaimInfo();
  }, []);
  
  const columns = [
    {
      title: 'Name',
      dataIndex: 'user_name',
      key: '1',
    },
    {
      title: 'Status',
      dataIndex: 'activity_status',
      key: '2',
    },
    {
      title: 'Claim Notes',
      dataIndex: 'claim_notes',
      key: '3',
    },
    {
      title: 'Date Modified',
      dataIndex: 'created_date',
      key: '4',
      render: created_date =>
        moment(created_date).format('YYYY-MM-DD HH:mm:ss'),
    },
  ]

  function downloadFile(val) {
    saveAs(val, 'Claim Uploaded Document')
  }

  function setVisibleFalse() {
    setViewPolicy(false)
  }

  async function authClaim() {
    let count = 0;
  
    claimData.claim_status = 'Approved';
    // claimData.user_name = localStorage.getItem('username');
    // claimData.user_id = localStorage.getItem('loggedInUserID');
  
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL + '/Claim/UpdateClaim/update',
        'POST',
        claimData
      );

      if(response.success)
      {
        window.location.href = '/claims';
        toast.success(response.data.message)
      }
      
    } catch (error) {
      toast.error(error.message)
      console.error('Error authorizing claim:', error);
    }
  
    // for (var i = 0; i < uploadedDoc.length; i++) {
    //   if (uploadedDoc[i].filename === 'Police File') {
    //     count = count + 1
    //   }
    //   if (uploadedDoc[i].filename === 'Quotation File') {
    //     count = count + 1
    //   }
    //   if (uploadedDoc[i].filename === 'Assesors Report') {
    //     count = count + 1
    //   }
    // }
    // if (count >= 3) {
    //   alert('Authorisable')
    //   claimData.claim_status = 'Authorised/Awaiting Payment'
    //   try {
    //     await apiRequest(BaseUrl + '/claim/CreateClaim', 'POST', claimData);
    //   } catch (error) {
    //     console.error('Error authorising claim:', error);
    //   }
    // } else {
    //   message.warning(
    //     'Claim cannot be Authorised untill Police Report,Copy of Drivers License,Quotations,Assessors Report are all uploaded',
    //   )
    // }
  }
  
  function ViewPolicyF(val) {
    let apiData
    let productId
    setLoading(true)
    if (val.includes('OTM')) {
      fetch('http://64.227.72.205:5001/api/v1/policy/' + val)
        .then(res => res.json())
        .then(data => {
          apiData = {
            productName: 'Motor Insurance',
            policyNo: data.policy_number,
            policyStartDate: data.policy_start_date,
            policyEndDate: data.policy_end_date,
            sumInsured: data.sum_insured,
            customerName: data.first_name + ' ' + data.surname,
            riskItemDetails: '',
            vrn: data.vrn,
          }
          setLoading(false)
          setPolicyData(apiData)
        })
    } else {
      if (val.includes('OTAAR')) {
        productId = 1
      } else if (val.includes('OTDC')) {
        productId = 2
      } else if (val.includes('OTFCP')) {
        productId = 3
      }
      fetch(
        process.env.REACT_APP_BASE_URL +
          '/Policy/GetPolicybynumber/' +
          val +
          ',' +
          productId,
      )
        .then(res => res.json())
        .then(data => {
          apiData = {
            productName: data.policydetail.productname,
            policyNo: data.policydetail.policynumber,
            policyStartDate: data.policydetail.policystartdate,
            policyEndDate: data.policydetail.policyexpirytdate,
            sumInsured: '',
            customerName: data.policydetail.customername,
            riskItemDetails: data.policydetail.riskitemdetails,
          }
          setLoading(false)
          setPolicyData(apiData)
        })
    }
    setViewPolicy(true)
  }

  return (
    <>
      <Layouts title="assets" classname="grid">
        <div className=" dash-bg-white">
          <div>
            <Row gutter={[16, 24]}>
              <Col xs={12} sm={24} md={12} lg={12}>
                <h3
                  style={{
                    color: '#F15A2B',
                    fontWeight: '700',
                    fontSize: '20px',
                    margin: '0',
                  }}>
                  Claim Details
                </h3>
              </Col>
            </Row>
            <Row gutter={[16, 24]} style={{display: 'inline'}}>
              <Col xs={24} md={12} lg={6}>
                <label>
                  <b>Customer Name : </b> {claimData && claimData.customer_name}
                </label>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <label>
                  <b>Claim No. : </b> {claimData && claimData.claim_number}
                </label>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <label>
                  <b>Policy No. : </b>
                  {claimData && claimData.policy_number}
                </label>
                <Tooltip title="View Policy Details">
                  <InfoCircleOutlined
                    style={{
                      position: 'relative',
                      zIndex: '999',
                      marginLeft: '10px',
                      color: '#29b0e5',
                    }}
                    onClick={() => ViewPolicyF(claimData.policy_number)}
                  />
                </Tooltip>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <label>
                  <b> Date of Loss : </b>
                  {claimData && claimData.date_of_loss}
                </label>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <label>
                  <b> Date of Notification :</b>{' '}
                  {claimData && claimData.date_of_notification}
                </label>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <label>
                  <b>Claim Amount : </b>
                  {claimData && claimData.claim_amount}
                </label>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <label>
                  <b>Claim Status : </b>
                  {claimData && claimData.claim_status}
                </label>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <label>
                  <b>Assigned To : </b>
                  {claimData && claimData.accessor_id}
                </label>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <label>
                  <b> Item Detail :</b> {claimData && claimData.itemdetails}
                </label>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <label>
                  <b> Approved Amount :</b>{' '}
                  {claimData && claimData.approved_amount}
                </label>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <label>
                  <b> Approved Amount Notes :</b>{' '}
                  {claimData && claimData.claim_notes}
                </label>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <label>
                  <b> Damage Description :</b>{' '}
                  {claimData && claimData.damage_description}
                </label>
              </Col>
            </Row>
          </div>
        </div>
        <div className=" dash-bg-white">
          <h3
            style={{
              color: '#F15A2B',
              fontWeight: '700',
              fontSize: '20px',
              margin: '0',
              marginBottom: '20px',
            }}>
            Uploaded Files
          </h3>

          <Row>
            <Col xs={24} md={12} lg={12}>
              <div className="dash-bg-white" style={{marginRight: '15px'}}>
                <div className="section-top-heading">
                  <h3
                    style={{
                      color: '#F15A2B',
                      fontWeight: '700',
                      fontSize: '20px',
                      margin: '0',
                      marginBottom: '20px',
                    }}>
                    {' '}
                    Police Report{' '}
                  </h3>
                </div>
                {uploadedDoc.length !== 0 && (
                  <div>
                    <ul>
                      {uploadedDoc.map(uploadedDocs => {
                        return (
                          <div>
                            {uploadedDocs.filename === 'Police File' && (
                              <label>
                                <b>
                                  {uploadedDocs.doc_path.slice(40)}
                                  &nbsp;&nbsp; <b>Created Date :</b>&nbsp;
                                  {uploadedDocs.created_date.slice(0, -16)}
                                  &nbsp;&nbsp;&nbsp;
                                  <Tooltip title="Download Document">
                                    <DownloadOutlined
                                      style={{color: 'green'}}
                                      onClick={() =>
                                        downloadFile(uploadedDocs.doc_path)
                                      }
                                    />
                                  </Tooltip>
                                </b>
                              </label>
                            )}
                          </div>
                        )
                      })}
                    </ul>
                  </div>
                )}
              </div>
            </Col>
            <Col xs={24} md={12} lg={12}>
              <div className="dash-bg-white" style={{marginRight: '15px'}}>
                <div className="section-top-heading">
                  <h3
                    style={{
                      color: '#F15A2B',
                      fontWeight: '700',
                      fontSize: '20px',
                      margin: '0',
                      marginBottom: '20px',
                    }}>
                    {' '}
                    Assessors Report{' '}
                  </h3>
                </div>

                {uploadedDoc.length !== 0 && (
                  <div>
                    <ul>
                      {uploadedDoc.map(uploadedDocs => {
                        return (
                          <div>
                            {uploadedDocs.filename === 'Assesors Report' && (
                              <label>
                                <b>
                                  {uploadedDocs.doc_path.slice(40)}
                                  &nbsp;&nbsp; <b>Created Date :</b>&nbsp;
                                  {uploadedDocs.created_date.slice(0, -16)}
                                  &nbsp;&nbsp;&nbsp;
                                  <Tooltip title="Download Document">
                                    <DownloadOutlined
                                      style={{color: 'green'}}
                                      onClick={() =>
                                        downloadFile(uploadedDocs.doc_path)
                                      }
                                    />
                                  </Tooltip>
                                </b>
                              </label>
                            )}
                          </div>
                        )
                      })}
                    </ul>
                  </div>
                )}
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={12} lg={12}>
              <div className="dash-bg-white" style={{marginRight: '15px'}}>
                <div className="section-top-heading">
                  <h3
                    style={{
                      color: '#F15A2B',
                      fontWeight: '700',
                      fontSize: '20px',
                      margin: '0',
                      marginBottom: '20px',
                    }}>
                    {' '}
                    Quotations{' '}
                  </h3>
                </div>

                {uploadedDoc.length !== 0 && (
                  <div>
                    <ul>
                      {uploadedDoc.map(uploadedDocs => {
                        return (
                          <div>
                            {uploadedDocs.filename === 'Quotation File' && (
                              <label>
                                <b>
                                  {uploadedDocs.doc_path.slice(40)}
                                  &nbsp;&nbsp; <b>Created Date :</b>&nbsp;
                                  {uploadedDocs.created_date.slice(0, -16)}
                                  &nbsp;&nbsp;&nbsp;
                                  <Tooltip title="Download Document">
                                    <DownloadOutlined
                                      style={{color: 'green'}}
                                      onClick={() =>
                                        downloadFile(uploadedDocs.doc_path)
                                      }
                                    />
                                  </Tooltip>
                                </b>
                              </label>
                            )}
                          </div>
                        )
                      })}
                    </ul>
                  </div>
                )}
              </div>
            </Col>
            {claimData && claimData.policy_number.includes('OTM') && (
              <Col xs={24} md={12} lg={12}>
                <div className="dash-bg-white" style={{marginRight: '15px'}}>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <div className="section-top-heading">
                      <h3
                        style={{
                          color: '#F15A2B',
                          fontWeight: '700',
                          fontSize: '20px',
                          margin: '0',
                          marginBottom: '20px',
                        }}>
                        {' '}
                        Copy of Driver's Licence{' '}
                      </h3>
                    </div>
                  </Col>
                  {uploadedDoc.length !== 0 && (
                    <div>
                      <ul>
                        {uploadedDoc.map(uploadedDocs => {
                          return (
                            <div>
                              {uploadedDocs.filename === 'Drivers License' && (
                                <label>
                                  <b>
                                    {uploadedDocs.doc_path.slice(40)}
                                    &nbsp;&nbsp; <b>Created Date :</b>&nbsp;
                                    {uploadedDocs.created_date.slice(0, -16)}
                                    &nbsp;&nbsp;&nbsp;
                                    <Tooltip title="Download Document">
                                      <DownloadOutlined
                                        style={{color: 'green'}}
                                        onClick={() =>
                                          downloadFile(uploadedDocs.doc_path)
                                        }
                                      />
                                    </Tooltip>
                                  </b>
                                </label>
                              )}
                            </div>
                          )
                        })}
                      </ul>
                    </div>
                  )}
                </div>
              </Col>
            )}
          </Row>
        </div>
        <div className=" dash-bg-white">
          <h3
            style={{
              color: '#F15A2B',
              fontWeight: '700',
              fontSize: '20px',
              margin: '0',
            }}>
            Claim Activity
          </h3>
          <br></br>
          <div className="table-grid-bx">
            <Table
              columns={columns}
              dataSource={claimActivity}
              scroll={{x: 768}}
            />
          </div>
          <div className="align-right">
            <Button
              onClick={authClaim}
              size="default"
              style={{
                backgroundColor: '#42cd6a',
                color: '#fff',
                padding: '0px 16px',
              }}>
              Authorise Claim
            </Button>
          </div>
        </div>

        <Modal
          title="Reject Claim"
          centered
          visible={cancelPopup}
          footer={null}
          onCancel={setVisibleFalse}
          width={1200}>
          <cancelClaimNote />
        </Modal>
        <Modal
          title="Details"
          centered
          visible={viewPolicy}
          footer={null}
          onCancel={setVisibleFalse}
          width={1200}>
          <ViewPolicyClaim parentToChild={policyData} />
        </Modal>
      </Layouts>
    </>
  )
}
